module.exports = __webpack_public_path__ + "static/heroVideo-9e2ac6c3900cc8ea3efdca16ff1300f4.mp4";